<div class="headline-container">
  <div mat-dialog-title>
    <su-headline h="h3" skin="primary">{{ data.title }}</su-headline>
  </div>

  <su-button
    [skin]="'secondary'"
    [icon]="'xmark'"
    (onClick)="dialogRef.close()"
    [ariaLabel]="'form.close' | translate">
  </su-button>
</div>

<div mat-dialog-content>
  <div *ngIf="expandableRequests.length > 0">
    <ng-container
      *ngFor="
        let item of expandableRequests;
        let itemIndex = index;
        let isLastItem = last
      ">
      <div
        *ngIf="item.quotationRequest"
        style="
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin: 1rem 0 0.75rem 0;
          padding-bottom: 0.5rem;
        ">
        <h3
          style="margin: 0; font-size: 0.875rem; font-weight: 600; color: #333">
          {{ 'taskmodule.shared.label__locations' | translate }}
        </h3>
        <span
          *ngIf="!data.hideRequestFromLabel"
          style="
            font-size: 0.875rem;
            font-weight: 600;
            color: var(--theme-primary-500);
          ">
          {{ 'taskmodule.task.offer.request_from' | translate }}
          {{ getRequestChangeDate(item.quotationRequest) }}
        </span>
      </div>

      <!-- Grouped locations by ArchObj -->
      <mat-accordion
        *ngIf="item.groupedLocations.length > 0"
        style="margin-bottom: 1.5rem">
        <mat-expansion-panel
          *ngFor="let group of item.groupedLocations"
          class="location-panel"
          (opened)="
            setPanelExpanded(
              'request-' + itemIndex + '-' + group.archObjId,
              true
            )
          "
          (closed)="
            setPanelExpanded(
              'request-' + itemIndex + '-' + group.archObjId,
              false
            )
          ">
          <mat-expansion-panel-header>
            <mat-panel-title
              style="
                display: flex;
                justify-content: space-between;
                align-items: center;
                width: 100%;
              ">
              <div style="flex: 1; font-weight: 500">
                [{{ group.archObjId }}]
                <span style="font-weight: normal">
                  <span
                    *ngIf="
                      group.archObj?.dtArchObjAddress?.[0]?.address
                        ?.streetName ||
                      group.archObj?.dtArchObjAddress?.[0]?.address?.houseNumber
                    ">
                    {{
                      group.archObj?.dtArchObjAddress?.[0]?.address?.streetName
                    }}
                    {{
                      group.archObj?.dtArchObjAddress?.[0]?.address
                        ?.houseNumber
                    }},
                  </span>
                  {{
                    group.archObj?.dtArchObjAddress?.[0]?.address?.postalCode
                  }}
                  {{ group.archObj?.dtArchObjAddress?.[0]?.address?.city }}
                </span>
              </div>
              <div
                *ngIf="
                  !isPanelExpanded(
                    'request-' + itemIndex + '-' + group.archObjId
                  )
                "
                style="font-weight: bold; color: #333; margin-left: 1rem">
                {{ 'taskmodule.task.offer.total_location_label' | translate }}:
                {{ calculateLocationSum(group) }} €
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div>
            <div style="display: flex; gap: 0.5rem; margin-bottom: 0.5rem">
              <span style="font-weight: bold"
                >{{
                  'taskmodule.shared.label__incidentDeviatingAddress'
                    | translate
                }}:</span
              >
              <span>{{ group.deviatingAddress || '-' }}</span>
            </div>
            <div style="display: flex; gap: 0.5rem">
              <span style="font-weight: bold"
                >{{
                  'taskmodule.shared.label__incidentFurtherInformation'
                    | translate
                }}:</span
              >
              <span>{{ group.furtherLocationInformation || '-' }}</span>
            </div>
          </div>
          <mtx-grid
            [columns]="requestServiceLineColumns"
            [data]="group.rows"
            [rowStriped]="true"
            [rowHover]="true"
            [pageSizeOptions]="[5, 10, 25, 50, 100]"
            [showPaginator]="false"
            [columnHideable]="true"
            [showSidebar]="false"
            [showToolbar]="true"
            [columnSortable]="true"
            [columnMenuButtonText]="'grid.columns_shown' | translate"
            columnMenuButtonType="flat"
            [columnPinnable]="false"
            [cellSelectable]="false"
            [rowClassFormatter]="requestRowClassFormatter">
          </mtx-grid>
          <div
            style="
              margin-top: 0.75rem;
              font-weight: bold;
              color: #333;
              text-align: right;
            ">
            {{ 'taskmodule.task.offer.total_location_label' | translate }}:
            {{ calculateLocationSum(group) }} €
          </div>
          <ng-container
            *ngIf="
              (item.filteredEquipmentGridRowsByArchObjId[group.archObjId]
                ?.length ?? 0) > 0
            ">
            <div
              style="
                margin-top: 1.5rem;
                margin-bottom: 0.5rem;
                font-weight: bold;
                font-size: 0.95em;
                color: #333;
              ">
              {{
                'taskmodule.task.offer.equipment_documentation.equipment_data_label'
                  | translate
              }}
            </div>
            <mtx-grid
              [columns]="equipmentGridColumns"
              [data]="
                item.filteredEquipmentGridRowsByArchObjId[group.archObjId] || []
              "
              [rowStriped]="true"
              [rowHover]="true"
              [showPaginator]="false"
              [columnHideable]="false"
              [showSidebar]="false"
              [showToolbar]="false"
              [columnSortable]="true"
              [columnPinnable]="false"
              [cellSelectable]="false"
              [rowClassFormatter]="equipmentRowClassFormatter">
            </mtx-grid>
          </ng-container>
        </mat-expansion-panel>
      </mat-accordion>

      <div
        *ngIf="item.quotationRequest"
        style="
          margin: 0.75rem 0 1.5rem 0;
          font-weight: bold;
          font-size: 1.1em;
          color: #333;
          text-align: right;
        ">
        {{ 'taskmodule.task.offer.total_label' | translate }}:
        {{ calculateRequestTotal(item.quotationRequest) }} €
      </div>

      <!-- Quotations (Angebote) section -->
      <ng-container *ngIf="item.quotations.length > 0">
        <ng-container
          *ngFor="
            let quotation of item.quotations;
            let quotationIndex = index;
            let isLastQuotation = last
          ">
          <div
            style="
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin: 1rem 0 0.75rem 0;
              padding-bottom: 0.5rem;
            ">
            <h3
              style="
                margin: 0;
                font-size: 0.875rem;
                font-weight: 600;
                color: #333;
              ">
              {{ 'taskmodule.shared.label__locations' | translate }} -
              {{ 'taskmodule.task.offer.offer_positions' | translate }}
            </h3>
            <span
              style="
                font-size: 0.875rem;
                font-weight: 600;
                color: var(--theme-primary-500);
              ">
              {{ 'taskmodule.task.offer.offer_from' | translate }}
              {{ getQuotationDate(quotation) }}
            </span>
          </div>

          <!-- Grouped quotation lines by ArchObj -->
          <mat-accordion style="margin-bottom: 1.5rem">
            <mat-expansion-panel
              *ngFor="let group of quotation.groupedLines"
              class="location-panel"
              (opened)="
                setPanelExpanded(
                  'quotation-' +
                    itemIndex +
                    '-' +
                    quotationIndex +
                    '-' +
                    group.archObjId,
                  true
                )
              "
              (closed)="
                setPanelExpanded(
                  'quotation-' +
                    itemIndex +
                    '-' +
                    quotationIndex +
                    '-' +
                    group.archObjId,
                  false
                )
              ">
              <mat-expansion-panel-header>
                <mat-panel-title
                  style="
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    width: 100%;
                  ">
                  <div style="flex: 1; font-weight: 500">
                    [{{ group.archObjId }}]
                    <span style="font-weight: normal">
                      <span
                        *ngIf="
                          group.archObj?.dtArchObjAddress?.[0]?.address
                            ?.streetName ||
                          group.archObj?.dtArchObjAddress?.[0]?.address
                            ?.houseNumber
                        ">
                        {{
                          group.archObj?.dtArchObjAddress?.[0]?.address
                            ?.streetName
                        }}
                        {{
                          group.archObj?.dtArchObjAddress?.[0]?.address
                            ?.houseNumber
                        }},
                      </span>
                      {{
                        group.archObj?.dtArchObjAddress?.[0]?.address
                          ?.postalCode
                      }}
                      {{ group.archObj?.dtArchObjAddress?.[0]?.address?.city }}
                    </span>
                  </div>
                  <div
                    *ngIf="
                      !isPanelExpanded(
                        'quotation-' +
                          itemIndex +
                          '-' +
                          quotationIndex +
                          '-' +
                          group.archObjId
                      )
                    "
                    style="font-weight: bold; color: #333; margin-left: 1rem">
                    {{
                      'taskmodule.task.offer.total_location_label' | translate
                    }}: {{ calculateQuotationLocationSum(group) }} €
                  </div>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div>
                <div style="display: flex; gap: 0.5rem; margin-bottom: 0.5rem">
                  <span style="font-weight: bold"
                    >{{
                      'taskmodule.shared.label__incidentDeviatingAddress'
                        | translate
                    }}:</span
                  >
                  <span>{{ group.deviatingAddress || '-' }}</span>
                </div>
                <div style="display: flex; gap: 0.5rem">
                  <span style="font-weight: bold"
                    >{{
                      'taskmodule.shared.label__incidentFurtherInformation'
                        | translate
                    }}:</span
                  >
                  <span>{{ group.furtherLocationInformation || '-' }}</span>
                </div>
              </div>
              <mtx-grid
                [columns]="quotationServiceLineColumns"
                [data]="group.rows"
                [rowStriped]="true"
                [rowHover]="true"
                [pageSizeOptions]="[5, 10, 25, 50, 100]"
                [showPaginator]="false"
                [columnHideable]="true"
                [showSidebar]="false"
                [showToolbar]="true"
                [columnSortable]="true"
                [columnMenuButtonText]="'grid.columns_shown' | translate"
                columnMenuButtonType="flat"
                [columnPinnable]="false"
                [cellSelectable]="false">
              </mtx-grid>
              <div
                style="
                  margin-top: 0.75rem;
                  font-weight: bold;
                  color: #333;
                  text-align: right;
                ">
                {{ 'taskmodule.task.offer.total_location_label' | translate }}:
                {{ calculateQuotationLocationSum(group) }} €
              </div>
              <ng-container
                *ngIf="
                  (item.filteredEquipmentGridRowsByArchObjId[group.archObjId]
                    ?.length ?? 0) > 0
                ">
                <div
                  style="
                    margin-top: 1.5rem;
                    margin-bottom: 0.5rem;
                    font-weight: bold;
                    font-size: 0.95em;
                    color: #333;
                  ">
                  {{
                    'taskmodule.task.offer.equipment_documentation.equipment_data_label'
                      | translate
                  }}
                </div>
                <mtx-grid
                  [columns]="equipmentGridColumns"
                  [data]="
                    item.filteredEquipmentGridRowsByArchObjId[
                      group.archObjId
                    ] || []
                  "
                  [rowStriped]="true"
                  [rowHover]="true"
                  [showPaginator]="false"
                  [columnHideable]="false"
                  [showSidebar]="false"
                  [showToolbar]="false"
                  [columnSortable]="true"
                  [columnPinnable]="false"
                  [cellSelectable]="false"
                  [rowClassFormatter]="equipmentRowClassFormatter">
                </mtx-grid>
              </ng-container>
            </mat-expansion-panel>
          </mat-accordion>

          <div
            style="
              margin: 0.75rem 0 1.5rem 0;
              font-weight: bold;
              font-size: 1.1em;
              color: #333;
              text-align: right;
            ">
            {{
              'taskmodule.task.offer.total_offer_positions_label' | translate
            }}: {{ calculateQuotationTotal(quotation) }} €
          </div>

          <div
            *ngIf="!isLastQuotation || !isLastItem"
            style="
              border-bottom: 1px solid #e0e0e0;
              margin: 1.875rem 0 1.875rem 0;
            "></div>
        </ng-container>
      </ng-container>

      <!-- No quotations message -->
      <div
        *ngIf="item.quotations.length === 0 && !data.hideNoQuotationsMessage"
        style="margin-bottom: 1.5rem">
        <div
          style="
            padding: 1rem;
            text-align: center;
            color: #999;
            font-size: 0.8125rem;
          ">
          {{ 'taskmodule.task.offer.no_quotations' | translate }}
        </div>
        <div
          *ngIf="!isLastItem"
          style="
            border-bottom: 1px solid #e0e0e0;
            margin: 1.875rem 0 1.875rem 0;
          "></div>
      </div>
    </ng-container>
  </div>

  <!-- Empty state -->
  <div
    *ngIf="expandableRequests.length === 0"
    style="
      padding: 3rem 1rem;
      text-align: center;
      color: #999;
      font-size: 0.875rem;
    ">
    {{ data.noEntriesMessage }}
  </div>
</div>

<ng-template #equipmentToggleCellTpl let-row>
  <div
    class="equipment-id-cell"
    [class.equipment-id-cell--parent]="isParentEquipmentRow(row)">
    <span *ngIf="!isParentEquipmentRow(row)">
      {{ getEquipmentIdDisplayValue(row) }}
    </span>
    <button
      *ngIf="isParentEquipmentRow(row)"
      type="button"
      class="equipment-row-toggle-button"
      (click)="onEquipmentToggleClick(row, $event)"
      [attr.data-equipment-group-key]="row?.__groupKey || ''"
      [attr.aria-expanded]="isEquipmentGroupRowExpanded(row?.__groupKey || '')"
      [attr.aria-label]="
        isEquipmentGroupRowExpanded(row?.__groupKey || '')
          ? ('taskmodule.task.offer.collective_equipment_collapse' | translate)
          : ('taskmodule.task.offer.collective_equipment_expand' | translate)
      ">
      <mat-icon
        aria-hidden="true"
        class="equipment-row-arrow"
        [class.equipment-row-arrow--expanded]="
          isEquipmentGroupRowExpanded(row?.__groupKey || '')
        ">
        expand_more
      </mat-icon>
    </button>
  </div>
</ng-template>
